if (!customElements.get('collection-items')) {   
  class CollectionItems extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }
  
    connectedCallback() {
      this.initSlider();
    }
  
    initSlider(){
      
      if (!this.querySelector('[data-slider]')) return;
      
      this.options = {
        slidesPerView: 1,
        spaceBetween: 8,
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        breakpoints: {
          768: {
            slidesPerView: 4,
          },
          1200: {
            slidesPerView: 5,
          }
        }
      }
  
      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options
      )
    }
  }
  
  customElements.define('collection-items', CollectionItems);
}
